import {
    FETCH_PROFILE_REQUEST,
    FETCH_PROFILE_SUCCESS,
    FETCH_PROFILE_ERROR,
    UPDATE_IMAGE_REQUEST,
    UPDATE_IMAGE_SUCCESS,
    UPDATE_IMAGE_ERROR,
    HIDE_PROFILE_LOADER,
    SHOW_PROFILE_LOADER,
    DELETE_IMAGE_REQUEST,
    DELETE_IMAGE_SUCCESS,
    DELETE_IMAGE_ERROR,
    RESET_IMAGE_REQUEST,
    RESET_IMAGE_SUCCESS,
    FETCH_PROFILE_JSON_REQUEST,
    FETCH_PROFILE_JSON_SUCCESS,
    FETCH_PROFILE_JSON_ERROR,
    CREATE_STATIC_QR_REQUEST,
    CREATE_STATIC_QR_SUCCESS,
    CREATE_STATIC_QR_ERROR,
    RESET_STATIC_QR_DATA,
} from './profile.constants';

export const resetStaticQrData = payload => ({
    type: RESET_STATIC_QR_DATA,
    payload,
});

export const createStaticQrRequest = payload => ({
    type: CREATE_STATIC_QR_REQUEST,
    payload,
});

export const createStaticQrSuccess = payload => ({
    type: CREATE_STATIC_QR_SUCCESS,
    payload,
});

export const createStaticQrError = payload => ({
    type: CREATE_STATIC_QR_ERROR,
    payload,
});

export const fetchProfileDetailsRequest = payload => ({
    type: FETCH_PROFILE_REQUEST,
    payload,
});

export const fetchProfileDetailsSuccess = payload => ({
    type: FETCH_PROFILE_SUCCESS,
    payload,
});

export const fetchProfileDetailsError = payload => ({
    type: FETCH_PROFILE_ERROR,
    payload,
});

export const fetchProfileJSONRequest = () => ({
    type: FETCH_PROFILE_JSON_REQUEST,
});

export const fetchProfileJSONSuccess = payload => ({
    type: FETCH_PROFILE_JSON_SUCCESS,
    payload,
});

export const fetchProfileJSONError = payload => ({
    type: FETCH_PROFILE_JSON_ERROR,
    payload,
});

export const updateImageRequest = payload => ({
    type: UPDATE_IMAGE_REQUEST,
    payload,
});

export const updateImageSuccess = payload => ({
    type: UPDATE_IMAGE_SUCCESS,
    payload,
});

export const updateImageError = payload => ({
    type: UPDATE_IMAGE_ERROR,
    payload,
});

export const deleteImageRequest = payload => ({
    type: DELETE_IMAGE_REQUEST,
    payload,
});

export const deleteImageSuccess = payload => ({
    type: DELETE_IMAGE_SUCCESS,
    payload,
});

export const deleteImageError = payload => ({
    type: DELETE_IMAGE_ERROR,
    payload,
});

export const resetImageRequest = () => ({
    type: RESET_IMAGE_REQUEST,
});

export const resetImageSuccess = () => ({
    type: RESET_IMAGE_SUCCESS,
});

export const showLoader = () => ({ type: SHOW_PROFILE_LOADER });

export const hideLoader = () => ({ type: HIDE_PROFILE_LOADER });
